import * as S from "@/containers/Project/components/styled";
import { Row, Typography } from "antd";
import { element, string } from "prop-types";

const { Text } = Typography;

const MobileTab = ({ icon, title }) => {
  const titleSplit = title.split(" ");

  return (
    <Row>
      <S.MobileViewTab>
        <div className="text-center">{icon}</div>
        {titleSplit.map((word, index) => (
          <div key={index} className="text-center">
            <Text>{word}</Text>
          </div>
        ))}
      </S.MobileViewTab>
    </Row>
  );
};

MobileTab.propTypes = {
  icon: element,
  title: string,
};

export { MobileTab };
